"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _default = function(string) {
    return "".concat(string.charAt(0).toLowerCase()).concat(string.replace(/[\W_]/g, "|").split("|").map(function(part) {
        return "".concat(part.charAt(0).toUpperCase()).concat(part.slice(1));
    }).join("").slice(1));
};
